export {GrowingDiscountLabel} from './GrowingDiscountLabel';
